module.exports = __webpack_public_path__ + "img/calendar-add.b0ff2e51.svg";